<template>
  <div v-if="isBlockVisible" class="ui-select-all">
    <template v-if="modelValue">
      <span>All {{ total }} {{ label }} are selected.&nbsp;</span>
      <button type="button" class="ui-link" @click="handleClearSelection">Clear selection</button>
    </template>
    <template v-else>
      <span>All {{ selected }} {{ label }} on this page are selected.&nbsp;</span>
      <button type="button" class="ui-link" @click="handleSelectAll">Select all {{ total }} {{ label }}</button>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, watchEffect } from 'vue'

type Props = {
  label: string
  total: number
  pageSize: number
  selected: number
}

const props = defineProps<Props>()

const modelValue = defineModel<boolean>({ required: true })

const isBlockVisible = computed(() => props.selected === props.pageSize && props.total > props.pageSize)

const handleSelectAll = () => {
  modelValue.value = true
}

const handleClearSelection = () => {
  modelValue.value = false
}

watchEffect(() => {
  if (isBlockVisible.value) return
  modelValue.value = false
})
</script>

<style scoped>
.ui-select-all {
  @apply py-2;
  @apply flex flex-col items-center justify-center sm:block;
  @apply text-sm sm:text-xs;
  @apply bg-primary-light;
  @apply text-center;

  .ui-link {
    @apply cursor-pointer;
  }
}
</style>
